angular.module 'zc.projects'

  .directive 'projectApikeyMenu', (Project) ->
    directive =
      restrict: "EA"
      scope: {}
      replace: true
      templateUrl: '/templates/projects/views/directives/project_apikey_menu.html'
      link: (scope) ->
        scope.Project = Project

    directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/project_apikey_menu.directive.coffee